import React from "react";

import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";

import SectionSchoolPlottedTable from "./section-school-plotted-table";
import { SectionTitle } from "./section-title";
import { STUDENT_BY_TITLE_DICTIONARY } from "./student-by.constants";
import { type StudentByProps } from "./student-by.types";

const StudentByComponent: React.FC<StudentByProps> = ({
  data,
  type,
}) => {
  const isColorByNone = type === StudentCountsInShapeColorByEnum.NONE;

  if (isColorByNone) return null;

  if (!data.length) return null;

  const title = STUDENT_BY_TITLE_DICTIONARY[type];

  return (
    <div>
      <SectionTitle title={title} />

      <SectionSchoolPlottedTable
        data={data}
        type={type}
      />
    </div>
  );
};

export default StudentByComponent;
